import angular from 'angular';
import uiRouter from 'angular-ui-router';
import SpendingComponent from './spending.component';

let SpendingModule = angular.module('Spending', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newSpending', {
            url: '/spendings/new?voucherId',
            component: 'spending',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR', 'VOUCHERCOLLECTOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService, EmployeesService) => {
                    return LoginService.getCurrent().then(user => {
                        if (user.employeeId) {
                            return EmployeesService.findById(user.employeeId)
                                .then(employee => {
                                    user.employee = employee;
                                    return user;
                                });
                        } else {
                            return user;
                        }
                    });
                },
            }
        })
        .state('editSpending', {
            url: '/spendings/:id',
            component: 'spending',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                spending: (
                    SpendingsService,
                    $stateParams
                ) => {
                    return SpendingsService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: ['employee', 'spendingType'],
                            deleted: true
                        }
                    });
                },
                user: (LoginService) => {
                    return LoginService.getCurrent();
                }
            }
        });
})
.component('spending', SpendingComponent)
.name;

export default SpendingModule;
